<template>
<div v-if="success == false">
  <div class="popupStyle-layout-1" style="height: auto; font-family: NanumSquareOTF;">
    <div class="title" style="margin-bottom: 44px;">
      수리 견적받기
    </div>

    <!-- 차량 정보 셀렉트 박스 -->
    <div class="title-area mb-32 mx-20" style="margin-bottom: 20px;">
      <h4 style="font-weight:bold; color:#666666;">차량정보 </h4>
      <element-select
        class="siri-selectbox"
        v-model="selectedCar.value"
        :label="selectedCar.label"
        :items="carInfo.items"
        :placeholder="carInfo.placeholder"
      ></element-select>
    </div>

    <!-- 희망지역 주소입력 -->
    <div class="title-area mb-32 mx-20">
      <h4 style="font-weight:bold; color:#666666;">희망지역 </h4>
      <div v-if="address != ''" style="font-weight: bold; font-family: NanumSquareOTF;">
        {{ address }}
      </div>
      <button v-if="address == ''" class="add-address-btn" id="plus-address-btn" @click="addressSearch()">
        주소입력
      </button>
      <button v-else class="add-address-btn2" id="plus-address-btn" @click="addressSearch()">
        주소수정
      </button>
    </div>
    <!-- 파손부위 사진 -->
    <div class="title-area mb-32 mx-20 ">
      <div class="image-titlearea">
        <h4>파손부위 사진 (5mb이하) </h4>
        {{ uploadedArr.length }}/10
      </div>
      <button v-if="uploadedArr.length != 10" class="add-address-btn" id="plus-address-btn" @click="handleUpload()">
        +사진 추가
      </button>
      <button v-else-if="uploadedArr.length == 10" class="add-address-btn3" id="plus-address-btn">
        +사진 추가
      </button>
      <input
        style="display:none;"
        id="upload-none"
        type="file"
        accept="jpg, png, gif, pdf"
        @change="selectedFile"
      />
      <div class="add-picture">

        <div class="img-row">
          <div
            class="img-each"
            v-for="(i, index) in uploadedArr"
            :key="index"
          >
            <el-button
              type="info"
              icon="el-icon-close"
              size="mini"
              circle
              @click="deleteFile(index)"
            ></el-button>
            <img :src="i.result" alt="" />
          </div>
          <div v-if="uploadedArr.length < 1" class="imagebox" />
          <div v-if="uploadedArr.length < 2" class="imagebox" />
        </div>
      </div>
    </div>

    <!-- 남기실 말씀 텍스트 에이리어 -->
    <div class="title-area mb-32 mx-20">
      <h4 style="font-weight:bold; color:#666666;">남기실 말씀 </h4>
      <textarea
        class="textarea-box-border"
        v-model="reservation_memo"
        type="text"
        maxlength="500"
        rows="5"
        placeholder="그 밖의 정비항목 또는 특별한 요구 사항이 있다면 입력해주세요"
      ></textarea>
    </div>

    <!-- 연락처 -->
    <div class="title-area mb-32 mx-20" style="margin-bottom: 100px;">
      <h4 style="font-weight:bold; color:#666666;">연락받을 휴대폰번호 </h4>
      <input
        class="input-box-border"
        v-model="phoneNum"
        type="text"
        placeholder="휴대폰번호를 입력해주세요"
      />
    </div>
  </div>

  <!-- 하단부 버튼 -->
  <ButtonBottom
    v-if="btnDisabled == true"
    :btnTitle="repairEstimateId ? '수정' : '신청'"
    :disabled="true"
    class="submit-btn"
    :click="clickNo">
  </ButtonBottom>
  <ButtonBottom
    v-else-if="btnDisabled == false"
    :btnTitle="repairEstimateId ? '수정' : '신청'"
    :disabled="false"
    class="submit-btn"
    :click="clickApply">
  </ButtonBottom>

  <!-- 주소검색 다이어로그 -->
  <el-dialog
    :visible.sync="dialog"
    width="400px"
    title="주소검색"
    :show-close="false" >
    <vue-daum-postcode @complete="searchAddress($event)" />
	</el-dialog>
</div>
<!-- 신청 완료시 완료 화면 -->
  <Success v-else-if="success == true"
    contents="무료 비교견적을<br>신청했습니다."
    contentsWeak="입력하신 내용을 바탕으로<br>최저견적을 찾아 드리겠습니다.<br>견적이 나오면 카카오톡으로 알려드립니다."
    :customOK="clickOkay">
  </Success>
</template>

<script>
import ButtonBottom from '@/components/Elements/ButtonBottom';
import Success from '@/components/Elements/Success'
import Vue from 'vue'
import {v4} from 'uuid'
import moment from 'moment'

export default {
  components: { ButtonBottom, Success },
  data() {
    return {
      repairEstimateId: '',
      repair_estimate_type: '수리',
      repair_estimate_date: '',
      autocode_name: '',
      auto_id: '',
      auto_code: '',
      uploadedArr: [],
      deleteUploadedArr: [],
      success: false,
      dialog: false,
      address: '',
      selectedCar: {
        label: '',
        value: '',
      },
      btnDisabled: true,
      reservation_memo: '',
      repair_estimate_memo: '',
      resource_key: '',
      phoneNum: '',
      carInfo: {
        value: '',
        items: [],
        placeholder: '차량 선택',
      },
    }
  },
  created() {
    if (this.$store.state.customer.profile.customer_phone_number != '') {
      this.phoneNum = this.$store.state.customer.profile.customer_phone_number
    }

    this.init()
  },
  watch: {
    selectedCar () {
      if ( this.address != '' ) {
        this.btnDisabled = false
      }
    },
    address () {
      if (this.selectedCar != '' ) {
        this.btnDisabled = false
      }
    }
  },
  methods: {
    init() {
      this.repairEstimateId = this.$route.query.repairEstimateId
      this.get_repair_estimate(this.$route.query.repairEstimateId)
    },
    get_repair_estimate(id) {
      if (!id) {
        this.getAutoList(this.$route.query.customerId)
        return false
      }
      return this.$store.dispatch(`repair/get`, { repairId: id, search_customer_id: this.$store.state.customer.profile._id })
        .then(({data}) => {
          const {
            auto_id,
            auto_code,
            autocode_name,
            reservation_memo,
            repair_estimate_memo,
            repair_estimate_type,
            repair_estimate_date,
            desired_area,
            resource_key,
            customer_id
          } = data.data
          this.address = desired_area
          this.selectedCar = {
            value: auto_id,
            label: autocode_name,
            _id: auto_id,
            auto_code,
          }
          this.reservation_memo = reservation_memo
          this.repair_estimate_memo = repair_estimate_memo
          this.resource_key = resource_key
          this.repair_estimate_type = repair_estimate_type
          this.repair_estimate_date = repair_estimate_date
          this.autocode_name = autocode_name
          this.auto_id = auto_id
          this.auto_code = auto_code
          this.load_list(data.data.resource_key)
          this.getAutoList(customer_id)
        })
    },
    getAutoList (customer_id) {
      const { profile } = this.$store.state.customer;

      if (!profile._id && !customer_id) {
        this.carInfo.items = [{label: this.autocode_name, value: this.auto_id}]
        return;
      }

      const customerId = customer_id ? customer_id : profile._id;
      
      return this.$store.dispatch('repair/getAutoItems', { customer_id: customerId })
        .then(({data}) => {
           this.carInfo.items = data.data.items.map(item => {
            const label = item.auto_number ? (' - ' + item.auto_number) : ''
            return {
              label: item.autocode_name + label,
              value: item._id,
              auto_code: item.auto_code
            }
          });
        })
    },
    clickNo () {
      return false
    },
    async clickApply () {
      const key = this.resource_key || v4().replace(/-/g, "")
      for await (const file of this.uploadedArr) {
        if (file.file) {
          const _form = new FormData();
          _form.append( 'file', file.file)
          _form.append( 'tag', '수리견적요청')
          _form.append( 'key', key )
          await this.$store.dispatch('repair/uploadResources', _form)
        }
      }

      for await (const file of this.deleteUploadedArr) {
        if (file.id) {
           await this.$store.dispatch('repair/deleteUploadResource/' + file.id)
        }
      }
      const url = this.repairEstimateId ? 'repair/edit' : 'repair/create';
      const customer_id = this.$route.query.repairEstimateId ? this.$store.state.customer.profile._id : this.$route.query.customerId;
      const auto_id = this.selectedCar._id || this.selectedCar.value;
      const auto_code = this.selectedCar.auto_code || this.carInfo.items.find(car => car.value === auto_id).auto_code;

      let payload = {
        data: {
          customer_id,
          auto_id,
          auto_code,
          desired_area: this.address,
          repair_estimate_type: this.repair_estimate_type,
          repair_estimate_status: '견적요청',
          repair_estimate_memo: this.reservation_memo,
          customer_phone_number: this.phoneNum,
          resource_key: key,
          repair_estimate_date: this.repair_estimate_date || moment().format('YYYY-MM-DD HH:mm:ss')
        }
      };

      if (this.repairEstimateId) {
        payload.repairEstimateId = this.repairEstimateId;
      }

      this.$store.dispatch(url, payload).then(() => {
        this.success = true;
      })
    },
    clickOkay () {
      window.location.href = '/'
    },
    addressSearch () {
      this.dialog = true
    },
    searchAddress (result) {
			this.address = result.address
			this.dialog = false
    },
    handleUpload() {
      document.getElementById('upload-none').click();
    },
    selectedFile(e) {
      let input = e.target;
      let reader = new FileReader();

      reader.onload = (e) => {
        if (this.uploadedArr.find(upload => upload.result === e.target.result)) {
          alert('이미 선택된 파일입니다.');
        } else {
          this.uploadedArr.push({result: e.target.result, file: input.files[0]});
        }
      };

      reader.readAsDataURL(input.files[0]);
    },
    deleteFile(index) {
      this.deleteUploadedArr.push(...this.deleteUploadedArr, ...this.uploadedArr.splice(index, 1))
    },
    load_list(resource_key) {
      var _params = { "key": resource_key, "page": 1, "size": 100 }
      this.$store.dispatch("repair/getResourceItems", {params:_params}).then(res => {
        let { data, error } = res.data;
        if (error) { return;  }
        this.$data.originUploadedArr = data.items
        this.$data.uploadedArr = data.items.map(item => ({result: item.resource_url, id: item.id}))
      })
    },
  },
}
</script>

<style lang="scss">
.image-titlearea {
  color: #666666;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.el-dialog__body {
  padding-top: 0px;
  padding-bottom: 15px;
}
.textarea-box-border {
  border-radius: 2px;
  margin-top: 5px;
  margin-bottom: 30px;
  border: 1px solid #D9D9D9;
  padding: 10px 15px 10px 15px;
}
.input-box-border {
  font-weight: bold;
  border-radius: 2px;
  margin-top: 5px;
  border: 1px solid #D9D9D9;
  padding: 10px 15px 10px 15px;
}
.siri-selectbox {
  margin-top: -10px;
}
.add-address-btn {
  margin-top: 5px;
  margin-bottom: 20px;
  border: solid 1px #174be6;
  color: #174be6;
  padding: 12px 10px;
}
.add-address-btn3 {
  cursor: auto;
  margin-bottom: 20px;
  margin-top: 5px;
  border: solid 1px black;
  color: black;
  padding: 12px 10px;
}
.add-address-btn3 {
  cursor: auto;
  margin-bottom: 20px;
  margin-top: 5px;
  border: solid 1px #D9D9D9;
  color: #D9D9D9;
  padding: 12px 10px;
}
.add-picture {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top:5px;
  margin-bottom: 24px;

  .img-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    // flex: 1 1 auto;

    .imagebox {
      /* position: relative; */
      /* width: 48%; */
      height: 150px;
      flex: 0 0 48%;
      margin-bottom: 16px;
      border: 2px dashed #D9D9D9;
    }
    .img-each {
      /* max-width: 45%; */
      /* width: 45%; */
      position: relative;
      flex: 0 0 48%;
      margin-bottom: 16px;

      button {
        background-color: rgba(0, 0, 0, 0.7);
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 10;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
